<template>
    <!-- 详情编辑 -->
    <div class="">
      <v-dialog
        class="popbox"
        name="dialog2"
        v-model="showInputDialog"
        :title="dialogTitle"
        close-on-click-modal
        :modal="true"
        :width="668"
        @open="showopen"
        @after-close="handleAfterClose"
        @confirm="handleConfirm"
        append-to-body
      >
        <v-form ref="form" :model="ruleForm" :rules="rules">
          <v-form-item label="版本ID" prop="id" :required="false" >
            <v-input type="text" name="id" v-model="ruleForm.id"  :disabled=true ></v-input>
          </v-form-item>
          <v-form-item label="产品" prop="product_keys"  >
            <v-select 
              isMultiple
              multipleShowAll
              id="product_keys"
              disabled
              is-search
              is-clear
              insertContains="product_keys" 
              :value="ruleForm.product_keys"
              name="product_keys" 
              :options="productKeyOptins"
            />
          </v-form-item>
          <v-form-item label="软件版本" prop="software_version"  >
            <v-input type="text" name="software_version" v-model="ruleForm.software_version"></v-input>
          </v-form-item>
          <v-form-item label="父版本" prop="previous_ver_id" :required="false">
          <v-select id="fat_target_version" is-search is-clear insertContains="fat_target_version" v-model="ruleForm.previous_ver_id" name="previous_ver_id" :options="resver"></v-select>
          </v-form-item>
          <v-form-item label="子版本" prop="target_ver_id" :required="false">
            <v-select id="son_target1_version" is-search is-clear insertContains="son_target1_version" v-model="ruleForm.next_ver_id" name="target_ver_id" :options="resver"></v-select>
          </v-form-item>
          <v-form-item class="listfile" label="固件上传" prop="listFile" :required="false">
                <v-upload
                action="/cgi-bin/upload"
                ref="upload"
                name="upload"
                accept=".trx,.bin"
                show-file-list
                :on-change="hidemsg"
                :WfileName="this.fileName"
                ></v-upload>
                <!-- <div class="filetip" ref="filetip">未选择文件</div> -->
              </v-form-item>
          <v-form-item label="版本类型" prop="version_type">
              <v-select id="list_edit_version_type" insertContains="list_edit_version_type" name="version_type" v-model="ruleForm.version_type" :options="versionTypeOptions"></v-select>
            </v-form-item>
          <v-form-item label="硬件版本" prop="hardware_version" >
            <v-input type="text" name="hardware_version" v-model="ruleForm.hardware_version"></v-input>
          </v-form-item>
          <v-form-item label="版本密码" prop="version_secret"  >
            <v-input type="text" name="version_secret" v-model="ruleForm.version_secret"></v-input>
          </v-form-item>

          <v-form-item label="公司" prop="enterprise_name">
            <v-input type="text" name="enterprise_name" v-model="ruleForm.enterprise_name"  ></v-input>
          </v-form-item>

          <v-form-item label="是否禁用云服务" prop="disabled_cloud" :required="false">
              <v-radio class="options" v-model="ruleForm.disabled_cloud" name="disabled_cloud" :options="disabledCloudOptions"></v-radio>
          </v-form-item>

          <v-form-item label="是否跳过当前版本" prop="recursion" :required="false">
              <v-radio class="options" v-model="ruleForm.recursion" name="recursion" :options="recursionList"></v-radio>
          </v-form-item>

          <v-form-item label="系统" prop="system" >
            <v-input type="text" name="system" v-model="ruleForm.system"></v-input>
          </v-form-item>

          <v-form-item label="作者描述" prop="author_description">
            <v-input type="textarea" class="Description" name="author_description" :maxlength="200" show-word-limit v-model="ruleForm.author_description"></v-input>
          </v-form-item>

          <v-form-item label="语言" prop="language">
            <v-checkbox-group v-model="languageData"  name="language"  @click="handleClick" :options="languageOptions"></v-checkbox-group>
          </v-form-item>
          <v-form-item prop="descpSelect" v-for="(item,index) in ruleForm.descp_lang" v-bind:key="index"  class="descp-language">
              <v-form-item  prop="change_log">
                <template slot="label">
                  <span class="required"></span>
                  <span>更新日志({{$LANGUAGE[item.language]}})</span>
                </template>
                <v-input type="textarea" class="Description" name="change_log" :maxlength="200" show-word-limit v-model="ruleForm.descp_lang[index].change_log"></v-input>
              </v-form-item>

              <v-form-item  prop="new_func">
                <template slot="label">
                  <span class="required"></span>
                  <span>新功能({{$LANGUAGE[item.language]}})</span>
                </template>
                <v-input type="textarea" class="Description" name="new_func" :maxlength="200" show-word-limit v-model="ruleForm.descp_lang[index].new_func"></v-input>
              </v-form-item>

              <v-form-item  prop="optimization">
                <template slot="label">
                  <span class="required"></span>
                  <span>优化内容({{$LANGUAGE[item.language]}})</span>
                </template>
                <v-input type="textarea" class="Description" name="optimization" :maxlength="200" show-word-limit v-model="ruleForm.descp_lang[index].optimization"></v-input>
              </v-form-item>

              <v-form-item  prop="memo">
                <template slot="label">
                  <span class="required"></span>
                  <span>备注({{$LANGUAGE[item.language]}})</span>
                </template>
                <v-input type="textarea" class="Description" name="memo" :maxlength="200" show-word-limit v-model="ruleForm.descp_lang[index].memo"></v-input>
              </v-form-item>
          </v-form-item>
        </v-form>
        <v-loading class="loading-box"  :visible="!upTips" name="loading4"></v-loading>

      </v-dialog>
    </div>
</template>

  <script>
import { copy } from '@/common/libs/utils';
import OSS from 'ali-oss'
import SparkMD5 from 'spark-md5'

  export default {
    components: {},
    props:{
    showInputDialog:{
      type:Boolean,
      default: false
    },
    row:{
      type:Object,
      default:()=>{}
    }
  },
    data() {
      return {
        notUse:'',
        filename_all:'',
        fileName:'',
        resver: [],
        rules: {
          software_version: copy([{
            type: "len",
            args: [1,128]
          }]),
          hardware_version: copy([{
            type: "ascii",
            args: [1,30]
          }]),
          version_secret: copy([{
            type: "ascii",
            args: [1,30]
          }]),
          enterprise_name: copy([{
            type: "len",
            args: [1,128]
          }]),
          system: copy([{
            type: "ascii",
            args: [1,30]
          }]),
        },
        ruleForm:{
          id:'',
          model: "",     // 产品型号
          software_version: "",    //软件版本
          version_type: "", //版本类型
          language: [],
          hardware_version: "",               //硬件版本
          version_secret: "",                              //版本密码
          enterprise_name: "",               //公司
          disabled_cloud: '',            //禁用云服务
          system: "",                   //系统
          author_description: "", //作者描述
          descp_lang: [],
          file_hash:'',
          file_url:'',
          image_size:0,
          previous_ver_id: '', //父版本id
          next_ver_id: '',   //子版本id
          recursion: 1,
          app_id: sessionStorage.getItem("appid") || "",
        },
        recursionList:[
          {
            label:'是',
            value: 1
          },
          {
            label:'否',
            value: 0
          }
        ],
        dialogTitle: "详情编辑",
        disabledCloudOptions:[
          {
            label: "禁用",
            value: 0
          },
          {
            label: "不禁用",
            value: 1
          }
        ],
        languageOptions:[
          {
            label:'中文简体',
            value:'zh-Hans'
          },{
            label:'中文繁体',
            value:'zh-Hant'
          },{
            label:'英文',
            value:'en'
          },{
            label:'乌克兰语',
            value:'uk'
          },{
            label:'俄罗斯语',
            value:'ru'
          },{
            label:'德语',
            value:'de'
          },{
            label:'波兰',
            value:'pl'
          },{
            label:'巴西葡语',
            value:'pt-BR'
          },{
            label:'土耳其',
            value:'tr'
          },{
            label:'印度尼西亚',
            value:'id'
          },{
            label:'韩文',
            value:'ko'
          },{
            label:'意大利',
            value:'it'
          },{
            label:'西班牙语',
            value:'es'
          },
        ],
        languageData:[],
        productKeyOptins: [],
        versionTypeOptions:[
            {
              label: "正式版",
              value: "release"
            },
            {
              label: "测试版",
              value: "beta"
            }
        ],

        upTips:true,
      };
    },
    created() {
      this.getData()
      this.getProductList()
      this.ruleForm = copy(this.row)
      this.constFilename()
      this.getversion()
      this.languageData = this.ruleForm.language.split(',')
    },
    methods: {
      handleClick(data) {
        const isNew = this.languageData.indexOf(data) === -1
        const index = this.languageData.indexOf(data)
        // this.ruleForm.language.indexOf(data) 值为-1时为新增，否则为删除，值为索引值
        if(isNew){
          this.ruleForm.descp_lang.push({
              language: data,
              change_log:'',
              new_func:'',
              optimization:'',
              memo:'',
          })
        }else{
          this.ruleForm.descp_lang.splice(index,1)
        }
      },
      async getversion(){
        const submitData = {
          type: this.ruleForm.version_type,
          app_id: sessionStorage.getItem("appid") || "",
          product_keys: this.row.product_keys
        }
        const res = await this.$getData(
          "/td/td-iot-api/iot/firmware/version-list/v1",submitData
        );
        this.resver = res.data.list
        this.resver.forEach((x)=>{
          this.productKeyOptins.map((item)=>{
            if(x.product_key == item.value){
              x.productName = item.label
            }
          })
          x.label = x.productName + "_"+  x.version  + "_" + x.type
          x.value = x.id
        })
      },
      constFilename(){
        this.fileName = this.ruleForm.file_url.split('/').at(-1)
      },
      showopen(){
        this.getversion()
        this.getData()
        this.ruleForm = copy(this.row)
        this.constFilename()
        this.languageData = this.ruleForm.language.split(',')
      },
      hidemsg(e,file){
      this.$message.warn("文件上传中,请等待...")
      this.upTips = false
      let _this = this
      // this.$refs.filetip.style.display = "none";
      if (window.FileReader) {
        var fi = e.target.files[0];
        this.ruleForm.image_size = fi.size
        const fileReader = new FileReader()
        fileReader.readAsBinaryString(fi);
        fileReader.onload = e => {
          const md5 = SparkMD5.hashBinary(e.target.result);
          _this.ruleForm.file_hash = md5.toUpperCase()
        }
       }
      this.address = this.ruleForm.version_type == 'release' ? `/${sessionStorage.getItem('appid') || ''}/firmware/release/` : `/${sessionStorage.getItem('appid') || ''}/firmware/beta/`
      this.client.put(`${this.address}` + file, e.target.files[0]).then((result) => {
        if(result.res.statusCode == 200){
          this.$message.success("文件上传成功")
          this.upTips = true
          this.ruleForm.file_url = result.url
        }else{
          this.$message.error("文件上传失败")
          this.upTips = true
        }
      })
    },
    async getData(){
      const res = await this.$getData(
        "/td/td-iot-api/iot/oss-bridge/sts-token/v1",
      );
      this.client = new OSS({
        region: 'oss-cn-shenzhen',
        secure:true,
        accessKeyId: res.data.access_key_id,
        accessKeySecret: res.data.access_key_secret,
        bucket: 'tenda-iot' ,
        stsToken:res.data.security_token
      });
    },
      getProductList(){
        const submitData = {
          app_id: sessionStorage.getItem("appid") || "",
        }
        this.$post("/td/td-iot-api/iot/common/product/list/v1", submitData, false).then((res) => {
          let code = +res.code;
          if (code === 0) {
            this.productKeyOptins = res.data.map((item) =>{
              return {
                label: item.product_name,
                value: item.product_key
              }
            })
          }else {
            this.$message.error(res.msg);
          }
        });
      },
      handleConfirm() {
        this.ruleForm.previous_ver_id =  Number(this.ruleForm.previous_ver_id)
        this.ruleForm.next_ver_id = Number(this.ruleForm.next_ver_id)
        const valid = this.$refs.form.submitForm();
        if (valid === false) {
          return;
        }
       this.ruleForm.language = this.languageData.toString()
        let submitData = { ...this.ruleForm };
        this.$put(`/td/td-iot-api/iot/firmware/v1/${this.row.id}`, submitData, false).then((res) => {
          let code = +res.code;
          if (code === 0) {
            this.$emit('getData')
            this.$message.success(res.msg);
          }
          else {
            this.$message.error(res.msg);
          }
        });
        this.$emit('getData')
        this.$emit('change')

      },
      handleAfterClose() {
        // this.$emit('getData')
        this.$emit('change')
      },

    },
    beforeDestroy() {},
  };
  </script>

  <style lang="scss">
    .v-edit .v-form-item .v-form-item__content {
      display: inline-block;
      margin-left: 24px!important;
    }
    .v-edit  #description .v-form-item__label--medium{
      line-height: 22px!important;
    }
    .v-edit .filetip{
     color:red
    }
  </style>
